{
    "LogFileDownload_DownloadTitle": "Descarregar **{}**",
    "LogFileDownload_HowManyFiles": "Quantos ficheiros anteriores gostaria de descarregar?",
    "LogFileDownload_AllFiles": "Todos os ficheiros",
    "LogFileDownload_NFile": "Ficheiro(s) {} passado(s)",
    "LogFileDownload_CurrentFile": "Ficheiro atual",
    "NAME": "LanguageLogFileDownload"
}